module.exports = __webpack_public_path__ + "img/smb-id-tag-white.256.aa692c75.png";